import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-organize-border bg-organize-bg px-3 py-2 text-sm text-vizimix-100 placeholder:text-vizimix-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-vizimix-500 focus-visible:ring-offset-2 focus-visible:ring-offset-organize-bg disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
